export default {
  networkError: 'network error',
  jsonDeserializationError: 'json deserialization error',
};
